export default "__VITE_ASSET__Dvu8ne5a__"